import {fetchTeamDetails} from "./teamDetailsActions";

export const TEAM_DETAILS_STAGES_OFFSET = 'TEAM_DETAILS_STAGES_OFFSET';
export const TEAM_DETAILS_SET_STAGE = 'TEAM_DETAILS_SET_STAGE';


export const setActiveAction = (index) => ({
    type: TEAM_DETAILS_SET_STAGE,
    payload: index
});
export const changeListOffsetAction = (change) => ({
    type: TEAM_DETAILS_STAGES_OFFSET,
    payload: change
});

export const onClassificationClickAction = (classification) => (dispatch, getStore) => {
    if (getStore().teamDetails.separatePerStage) {
        dispatch(fetchTeamDetails(getStore().teamDetails.team.id, classification.id))
    }
    dispatch(setActiveAction(classification.index))
};